module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-profile-hugh.73b970f.png";